const EMAIL_PATTERN = /^[^@]+@[^@]+$/;

export const selectDisplayName = state => {
  return state.invite.displayName;
};

export const selectEmail = state => {
  return state.invite.email;
};

export const isDisplayNameValid = state => {
  return !!selectDisplayName(state);
};

export const isEmailValid = state => {
  const email = selectEmail(state);
  return !!email && email.match(EMAIL_PATTERN);
};

export const isAttempted = state => {
  return state.invite.isAttempted;
};

export const isSubmitting = state => {
  return state.invite.isSubmitting;
};

export const isEmailDuplicate = state => {
  return state.invite.isEmailDuplicate;
};
